import {RoomFile} from "@/core/api/room.file.api";
import _ from 'lodash'

export default {
    deleteRoomFile: async({dispatch, commit, getters, rootGetters}, {file}) => {
        await RoomFile.deleteRoomFile({roomFileId: file.roomFileId});
    },
    uploadRoomFile: async({ dispatch, commit, getters, rootGetters }, files) => {
        if (!files || files.length === 0) {
            return;
        }
        
        for(let i = 0; i < files.length; i++) {
            let file = files.item(i);
            let fileExt = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            if (getters['allowedRoomFileExts'].length > 0 && !getters['allowedRoomFileExts'].includes(fileExt)) {
                throw new Error('not supported extension, ' + file.name)
            }
            const reqId = Date.now() + ((min, max) => {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
            })(0, 100);
            
            let uploadObj = {
                reqId,
                size: file.size,
                filename: file.name,
            };
            
            commit('UPLOAD_ROOM_FILE', _.merge({
                loaded: 0,
                progress: 0,
                startTime: Date.now(),
                downloadState: 'uploading',
                fileInfo: {
                    filename: file.name,
                    filesize: file.size,
                },
            }, uploadObj));

            let res;
            try{
                res = await RoomFile.getUploadUrl(uploadObj);
                if(!res.url) {
                    throw new Error();
                }
            }catch (e) {
                commit('REMOVE_UPLOAD_ROOM_FILE', uploadObj);
                throw e;
            }
            const {url, storageType} = res;
            _.merge(uploadObj, {
                url,
                storageType,
            });
            
            try{
                let result = await RoomFile.uploadToPresignedUrl({
                        url, file, onUploadProgress: e => {
                            commit('CHANGE_UPLOAD_ROOM_FILE', {
                                reqId,
                                loaded: e.loaded
                            });
                        }
                    });
                await RoomFile.completeUploadToPresignedUrl(uploadObj);
            }catch (e) {
                console.error('Cound not upload to Presigned-Url', e);
                throw e;
            }finally {
                commit('REMOVE_UPLOAD_ROOM_FILE', uploadObj);
            }            
        }
    },
    getRoomFileUrl: async({dispatch, commit, getters, rootGetters}, data) => {
        let {roomFileId} = data;
        return await RoomFile.getRoomFileUrl({roomFileId});
    },
}
